/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useRef, useState } from "react";
import RefreshLoading from "components/RefreshLoading";
import MainHomePage from "./Components/MainHomePage";

import { Grid } from "@material-ui/core";
import { HEIGHT_FOOTER } from "config/constant";
import { PullToRefresh } from "react-js-pull-to-refresh";
import { useIsInViewport } from "config/hook";

const height = `calc(100vh - ${HEIGHT_FOOTER}px)`;

const PagePullToRefresh = props => {
	const {
		totalNotification,
		infoShop,
		dataInfoLoyalty,
		listLoyalty,
		products,
		business,
		totalListProduct,
		carts,
		handleSearchProduct,
		handleInfoLoyaltyDefault,
		handleClickProgram,
		setConfirmReward,
		updateChangeListProduct,
		dispatchAlertMessage,
		dispatchGetCRMShopInfoDetail,
		dispatchGetCRMRewardDetail,
		dispatchGetListProduct
	} = props;

	const [heightScroll, setHeightScroll] = useState(0);
	const [heightProductsScroll, setHeightProductsScroll] = useState(0);
	const [isOnTouch, setIsOnTouch] = useState(false);
	const [isScrollTopListProduct, setScrollTopListProduct] = useState(false);
	const [isPull, setPull] = useState(false);

	const refFirstElement1 = useRef(null);
	const refProductListScroll = useRef(null);
	const isInViewport = useIsInViewport(refFirstElement1);
	const isSignRewardConfirm = infoShop?.isSignRewardConfirm || false;

	const refreshHandler = () => {
		setPull(true);
		return new Promise(resolve => {
			setTimeout(() => {
				dispatchGetCRMShopInfoDetail();
				if (isSignRewardConfirm) {
					dispatchGetCRMRewardDetail();
				}
				setPull(false);
				setIsOnTouch(false);
				resolve();
			}, 2000);
		});
	};

	const handleScroll = event => {
		const position = event.target.scrollTop;
		setHeightScroll(position);
		const divTop = refProductListScroll.current.getBoundingClientRect().top;
		if (divTop <= 0) {
			setScrollTopListProduct(true);
		} else {
			setScrollTopListProduct(false);
		}
	};

	const handleOnTouchStartPull = () => {
		setIsOnTouch(true);
	};

	const displayForPull = (isOnTouch, heightScroll, heightProductsScroll) => {
		if (isOnTouch) {
			return "block";
		}
		if (heightScroll > 0 || heightProductsScroll > 0) {
			return "none";
		}
		return "block";
	};

	return (
		<PullToRefresh
			pullDownContent={<Grid style={{ height: 100 }} />}
			refreshContent={<RefreshLoading />}
			releaseContent={<RefreshLoading />}
			pullDownThreshold={100}
			onRefresh={refreshHandler}
			triggerHeight={isInViewport ? height : 1}
			startInvisible={false}
		>
			<div
				ref={refFirstElement1}
				id="firtsHome"
				style={{
					height: 0,
					display: displayForPull(
						isOnTouch,
						heightScroll,
						heightProductsScroll
					)
				}}
			/>
			<MainHomePage
				refProductListScroll={refProductListScroll}
				isScrollTopListProduct={isScrollTopListProduct}
				isPull={isPull}
				totalNotification={totalNotification}
				infoShop={infoShop}
				dataInfoLoyalty={dataInfoLoyalty}
				listLoyalty={listLoyalty}
				products={products}
				totalListProduct={totalListProduct}
				carts={carts}
				business={business}
				height={height}
				heightScroll={heightScroll}
				handleScroll={handleScroll}
				setHeightProductsScroll={setHeightProductsScroll}
				handleSearchProduct={handleSearchProduct}
				handleInfoLoyaltyDefault={handleInfoLoyaltyDefault}
				handleClickProgram={handleClickProgram}
				setConfirmReward={setConfirmReward}
				updateChangeListProduct={updateChangeListProduct}
				dispatchAlertMessage={dispatchAlertMessage}
				dispatchGetListProduct={dispatchGetListProduct}
				handleOnTouchStartPull={handleOnTouchStartPull}
			/>
		</PullToRefresh>
	);
};

export default memo(PagePullToRefresh);
